import { Component, Injector, ViewChild } from '@angular/core';
import type { OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { CustomerMessagesBasePage } from '@shared/pages';
import { CustomerMessagesComponent } from '@shared/components';
import type { CustomerMessageConfig, CustomerMessageData } from '@shared/components';
import type { TAllAboard, TCustomer } from '@shared/models';

@Component({
    'selector': 'app-dropoffAllAboard',
    'templateUrl': './dropoffAllAboard.page.html',
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule, CustomerMessagesComponent ]
})
export class DropoffAllAboardPage extends CustomerMessagesBasePage implements OnInit {
    @ViewChild(CustomerMessagesComponent) public customerMessagesComponent: CustomerMessagesComponent;
    
    public isDebugMode = false;
    public override vm: CustomerMessageData = {
        enabled: false,
        numMinutes: 5,
        rawMessage: '',
        renderedMessage: '',
        message: '',
        enabledStr: ''
    };

    public config: CustomerMessageConfig = {
        enabledLabel: 'Send the all aboard message.',
        disabledLabel: 'Do NOT send the all aboard message.',
        messageLabel: 'All Aboard Message',
        messagePreviewLabel: 'Message Appears As:',
        hasRangeSlider: true,
        rangeConfig: {
            label: 'Customer Alert Minutes',
            min: 1,
            max: 10,
            propertyName: 'numMinutes'
        }
    };

    public settings: any = {};
    public submitted = false;
    private defaultNumMinutes = 5;

    constructor(injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_ALL_ABOARD);
        super.setMessageNameEvent(this.Constants.EVENT_ALL_ABOARD);
        super.setDefaultMessage(this.Constants.SETTINGS_DROPOFF_ALLABOARD_MSG);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        // super.helpDocName = Constants.VIEW_SETTINGS_ALL_ABOARD; // this.HELP_DOCUMENT;
        try {
            this.isDebugMode = (this.sessionService.isDebugMode());
            await this.uxHelperService.showSpinner();
            const settings = await this.settingsService.get();
            this.settings = settings || {};
            this.vm = this.settings.allAboard;
            if (!this.vm) {
                this.vm = {} as CustomerMessageData;
                this.vm.enabled = true;
                this.vm.numMinutes = this.defaultNumMinutes;
                this.loadDefaultMessage();
            }

            // Initialize enabledStr based on enabled state
            this.vm.enabledStr = this.vm.enabled ? this.config.enabledLabel : this.config.disabledLabel;
            await this.uxHelperService.hideSpinner();
            this.initMoreMenu();
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.supplyCustomerMenuItems();
        // this.pushPopoverMenuItem('Show Tour', 'show-all-aboard-tour');
        this.moreMenuItemClick(this.handleMenuItemClick);
    }

    public async onSaveClick(form?: NgForm): Promise<void> {
        this.submitted = true;
        
        // Get form from child component if not passed
        const formToValidate = form || this.customerMessagesComponent?.form;
        
        if (!formToValidate || !formToValidate.valid) {
            return;
        }

        try {
            this.settings.allAboard = {
                'enabled': this.vm.enabled,
                'numMinutes': this.vm.numMinutes,
                'rawMessage': this.vm.rawMessage,
            };
            await this.uxHelperService.showSpinner('Saving.');
            await this.settingsService.update(this.settings);
            await this.uxHelperService.hideSpinner();
            this.uxHelperService.showToast('Saved.');
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error:', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
            this.router.navigateByUrl('/managerSettings');
        }
    }
}
